import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import "../css/template_custom.css";
import "../css/template_menu.css";
import "../css/appShell.css";
import "../libs/menu_js.js";
// lib-filter: widget lọc (icon filter trong <th>) dùng chung với khu admin.
// Trước đây chỉ AdLayout/AdminLayout import nên các filter-ib ở trang user
// (OrderTable, TthOrderTable…) không hoạt động khi vào thẳng — load ở đây để
// window.initializeFilterValue/getFormData sẵn sàng cho toàn bộ khu user.
import "../libs/lib-filter/lib-filter.css";
import "../libs/lib-filter/lib-filter.js";
import PrivateRoute from "../PrivateRoute";
import Header from '../components/Header';
import AppFooter from '../components/AppFooter';

// Mandatory shell for every logged-in user/* page.
// Uses the SAME <Header /> as the public site (Home, Chính sách, Liên hệ…) so
// the logged-in customer sees ONE consistent menu everywhere instead of the
// menu changing between pages. AppFooter stays as the compact internal footer.
const UserLayout = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const normalizedRole = String(user?.role || "").toLowerCase();
  // Khách hàng không hiển thị footer; chỉ admin/member xem portal khách mới thấy.
  const isCustomer = !(user?.isAdmin === true || user?.isMember === true
    || normalizedRole === "admin" || normalizedRole === "administrator");

  useEffect(() => {
    var menuClass = sessionStorage.getItem('menu_class');
    if (!menuClass) menuClass = 'nav-md';
    document.body.classList.add(menuClass);
  }, []);

  return (
    <div className="web-cover1 app-shell">
      <PrivateRoute roles={['user']}>
        <Header />
        <div className="web-main bg-white app-shell__content overflow-hidden">
          {children}
        </div>
        {!isCustomer && <AppFooter />}
      </PrivateRoute>
    </div>
  );
};

export default UserLayout;
